import AlexStates from './AlexStates';
import { playAudio, setCaption } from '../audio/audioActions';
import { startSpeaking, stopSpeaking } from '../avatar/avatarActions';
import { blockScreen, unblockScreen, setPauseButtonActive, setPauseButtonInactive, setShouldDisplayCaption } from '../screen/screenActions';

export const SET_ALEX_STATE = 'SET_ALEX_STATE';
export const SET_ALEX_ANIMATION = 'SET_ALEX_ANIMATION';

export const setAlexState = payload => ({
    type: SET_ALEX_STATE,
    payload,
});

export const setShouldPreventAlexAnimation = payload => ({
    type: SET_ALEX_ANIMATION,
    payload,
});

export const playAlexAudio = (audioFiles, caption = '') => {
    const instructionArray = Array.isArray(audioFiles) ? audioFiles : [audioFiles];
    return dispatch => {
        return dispatch(
            playAudio(
                instructionArray,
                0,
                () => {
                    dispatch(blockScreen());
                    dispatch(startSpeaking());
                    dispatch(setPauseButtonActive());
                    dispatch(setShouldDisplayCaption(true));
                    dispatch(setCaption(caption));
                    dispatch(setAlexState(AlexStates.SPEAKING));
                },
                () => {
                    dispatch(unblockScreen());
                    dispatch(stopSpeaking());
                    dispatch(setPauseButtonInactive());
                    dispatch(setShouldDisplayCaption(false));
                    dispatch(setAlexState(AlexStates.INACTIVE));
                },
            ),
        );
    };
};
